import React from 'react'

export default function ResultPhoto(props) {

    return (
        <table className="Result_table" style={{ height: props.ResultHeight + 'px' }}>
            <thead>
                <tr style={{paddingRight:"6px"}}>
                    <th className="Result_checkBox">
                        <input type="checkbox" id="allCheck" style={{margin:"0"}}
                            onClick={(e)=>props.onChangeRemoveAllCheck(e,props.items.map(item=>item.id))}
                            disabled={props.isUpdate}/>
                    </th>
                    <th className="Result_items"  style={{width:"calc(100% - 301px)"}}>
                        <div>ファイル名</div>
                        <div>タグ</div>
                    </th>
                    <th className="Result_items" style={{width:"200px"}}>
                        <div>アップロード日時</div>
                        <div>撮影日時</div>
                    </th>
                    <th className="Result_items" style={{width:"70px",display:"flex",justifyContent:"center",alignItems:"center"}}>
                        <div>位置設定の状態</div>
                    </th>
                </tr>
            </thead>
            <tbody style={{ height: (props.ResultHeight - 50) + 'px' }}>
                {props.items && props.items.map(item =>
                    <tr className={"Result_row" + (props.selectedItem != null && props.selectedItem?.id === item.id ? " Result_row_active":"") + (props.oldSelectedItem != null && props.oldSelectedItem?.id === item.id ? " photoResult_row_focus":"")}
                        onClick={(e)=>!props.isUpdate ? props.onChangeSelectedRowAndEditClear(item,e,true,false):null}
                        onMouseEnter={() =>!props.isUpdate ? props.onEnterItem(item):null }  
                        onMouseLeave={() =>!props.isUpdate ? props.onLeaveItem(item):null }
                        key={item.id}
                        id={item.id}>
                        <td className="Result_checkBox" onClick={(e)=>props.onChangeRemoveCheck(e,item.id)}>
                            <input type="checkbox" id="checkbox1" className="Result_checkBox_box" 
                                onClick={(e)=>props.onChangeRemoveCheck(e,item.id)}
                                disabled={props.isUpdate}/>
                        </td>
                        <td className="Result_items" style={{width:"calc(100% - 301px)"}}>
                            <div className="Result_item" style={{wordBreak: "break-all",wordWrap: "break-word",textAlign:"left" }} >
                                {item.title}
                            </div>
                            <div className="Result_item" >
                            {item.tags !== undefined && item.tags !== null && item.tags.length !== 0 ? item.tags.map((tag,index) =>
                                <button onClick={()=>props.onTagClick(`#${tag}`)} className="link-style-btn Result_tag" 
                                style={{ fontWeight: 'bold',wordBreak: "break-all",wordWrap: "break-word",textAlign:"left" }} 
                                key={index} disabled={props.isUpdate}>#{tag}</button> ) : ""}
                            </div>
                        </td>
                        <td className="Result_items" style={{width:"200px"}}>
                            <div className="Result_item" >{item.uploadDateTime}</div>
                            <div className="Result_item" >{item.filmingDateTime}</div>
                        </td>
                        <td className="Result_items" style={{width:"70px",display:"flex",justifyContent:"center",alignItems:"center"}}>
                            <div className="Result_item" >
                                {
                                    item.locationSettingFlg && item.directionSettingFlg ? <i className="bi bi-circle"></i> 
                                        : <i className="bi bi-exclamation-lg"></i>
                                }
                            </div>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}
